import type React from 'react';

interface JoinActionsProps {
  isHintVisible: boolean;
  onOpenApp: () => void;
  onJoinInBrowser: () => void;
}

export const JoinActions: React.FC<JoinActionsProps> = ({
  isHintVisible,
  onOpenApp,
  onJoinInBrowser,
}) => (
  <>
    <div className="mobile-app-redirect__actions">
      <button
        type="button"
        onClick={onOpenApp}
        className="mobile-app-redirect__button mobile-app-redirect__button--primary"
      >
        Open App &amp; Join
      </button>
      <button
        type="button"
        onClick={onJoinInBrowser}
        className="mobile-app-redirect__button mobile-app-redirect__button--secondary"
      >
        Join in browser
      </button>
    </div>

    {/* `output` is an implicit live region, so the hint is announced when it appears. */}
    {isHintVisible && (
      <output className="mobile-app-redirect__hint">
        Didn't open? Install the app below, or join in browser.
      </output>
    )}
  </>
);
